export default __webpack_public_path__ + "static/media/rafa7.705bcd46.jpg";